<template>
  <div class="login">
    <!-- sisi kuning -->
    <div class="left-side">
      <img class="oval" src="../../assets/img/oval.png" alt="" srcset="" />
      <img class="oval-2" src="../../assets/img/oval.png" alt="" srcset="" />
      <!-- logo -->
      <img
        style="margin-bottom: 12px"
        width="212px"
        src="../../assets/img/logo.png"
        alt=""
        srcset=""
      />
      <!-- end of logo -->

      <!-- text -->
      <div class="nama-deskripsi">
        <p>
          Perusahaan agribisnis dan agrowisata <br />
          terbaik di Yogyakarta
        </p>
      </div>
      <!-- end of text -->
    </div>
    <!-- end of sisi kuning -->

    <!-- sisi putih -->
    <div class="right-side">
      <div class="text">
        <h2>Login</h2>
        <p>Masuk dengan akun anda</p>
      </div>
      <!-- input email -->
      <div ref="email-form" class="box-form email">
        <svg
          width="18"
          height="16"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1429 2.71434C15.1429 1.92862 14.5 1.28577 13.7143 1.28577H2.28575C1.50003 1.28577 0.857178 1.92862 0.857178 2.71434M15.1429 2.71434V11.2858C15.1429 12.0715 14.5 12.7143 13.7143 12.7143H2.28575C1.50003 12.7143 0.857178 12.0715 0.857178 11.2858V2.71434M15.1429 2.71434L8.00003 7.71434L0.857178 2.71434"
            stroke="#A0A3BD"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="input-and-title">
          <span style="display: none" class="input-title">Email</span>
          <input
            @keyup.enter="login"
            v-model="email"
            @keyup="inputChanged($event)"
            class="input-text"
            required
            placeholder="Email"
            type="text"
          />
        </div>
      </div>
      <!-- end of input email -->

      <!-- input password -->
      <div ref="password-form" class="box-form email">
        <svg
          width="16"
          height="18"
          viewBox="0 0 14 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.42855 7.28575V4.42861C3.42855 3.4814 3.80483 2.573 4.4746 1.90322C5.14437 1.23345 6.05278 0.857178 6.99998 0.857178C7.94718 0.857178 8.85559 1.23345 9.52536 1.90322C10.1951 2.573 10.5714 3.4814 10.5714 4.42861V7.28575M1.99998 7.28575H12C12.789 7.28575 13.4286 7.92534 13.4286 8.71432V13.7143C13.4286 14.5033 12.789 15.1429 12 15.1429H1.99998C1.211 15.1429 0.571411 14.5033 0.571411 13.7143V8.71432C0.571411 7.92534 1.211 7.28575 1.99998 7.28575Z"
            stroke="#A0A3BD"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <div class="input-and-title">
          <span style="display: none" class="input-title">Password</span>
          <input
            @keyup.enter="login"
            v-model="password"
            @keyup="inputChanged($event)"
            class="input-text"
            required
            placeholder="Password"
            type="password"
          />
        </div>
      </div>
      <!-- end input password -->

      <br />
      <div class="button-and-failed-input">
        <button :disabled="isProcessing" @click="login" class="button-login">
          <div ref="spinner" style="display: none" class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <span ref="button-login-text">Login</span>
        </button>
        <p v-if="isFailed" class="failed-input">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.26795 5C9.03775 3.66667 10.9623 3.66667 11.7321 5L16.9282 14C17.698 15.3333 16.7358 17 15.1962 17H4.80385C3.26425 17 2.302 15.3333 3.0718 14L8.26795 5Z"
              fill="#EB5757"
            />
            <path
              d="M10.55 8L10.37 13H9.18L9 8H10.55ZM10.54 13.88V15.35H9.02V13.88H10.54Z"
              fill="#FCFCFC"
            />
          </svg>
          Email atau password salah, coba lagi
        </p>
      </div>
    </div>
    <!-- end of sisi putih -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as soluhaFire from "../../soluhafire";

export default {
  data() {
    return {
      isProcessing: false,
      email: "",
      password: "",
      // status gagal input
      isFailed: false,
    };
  },

  methods: {
    // cek perubahan input untuk munculin input title
    inputChanged(event) {
      let title = event.target.previousSibling;
      if (event.target.value.length > 0) title.style.display = "block";
      else title.style.display = "none";
    },

    // ketika salah input form
    wrongAuth() {
      this.$refs["email-form"].classList.add("failed-box-form");
      this.$refs["password-form"].classList.add("failed-box-form");
      this.isFailed = true;
    },

    // login
    async login() {
      // proses dimulai
      this.isFailed = false;
      this.isProcessing = true;
      let textButton = this.$refs["button-login-text"];
      let spinner = this.$refs["spinner"];
      textButton.style.display = "none";
      spinner.style.display = "block";
      let result = await soluhaFire.login(this.email, this.password);
      // proses selesai
      if (result) {
        this.accessPage();
        this.isProcessing = false;
        textButton.style.display = "block";
        spinner.style.display = "none";
      } else {
        this.wrongAuth();
        this.isProcessing = false;
        textButton.style.display = "block";
        spinner.style.display = "none";
      }
    },

    // pindah page sesuai dengan role
    accessPage() {
      setTimeout(() => {
        if (this.userData.divisi === "humanResource")
          this.$router.push("/hrd/dashboard");
        else if (this.userData.divisi === "nonDivisi")
          this.$router.push("/non-divisi/presensi/PresensiCamera");
        else if (this.userData.divisi === "finance")
          this.$router.push("/finance/dashboard");
        else if (this.userData.divisi === "marketing")
          this.$router.push("/marketing/dashboard");
        else if (this.userData.divisi === "gudang")
          this.$router.push("/gudang/dashboard");
        else if (this.userData.divisi === "ceo")
          this.$router.push("/ceo/finance");
      }, 2000);
    },
  },

  computed: {
    ...mapState(["userData"]),
  },
};
</script>

<style scoped>
@import url("../../assets/css/login.css");

.failed-box-form {
  border-color: #eb5757;
}

.failed-box-form * {
  color: #eb5757;
  stroke: #eb5757;
}

button:disabled,
button[disabled] {
  background: #a0a3bd;
  color: white;
}
</style>
